import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'

export const fetchWellnessChecks = async (deviceId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_WELLNESS_API_URL}/wellness/${deviceId}`, error_message: "Failed to load check-in history" });
};

export const fetchDeviceFormResponse = async (deviceId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_API_ORIGIN}/portalform/device_form_response/${deviceId}`, error_message: "Failed to get forms" });
};

export const addWellnessCheck = async (deviceId, score, notes) => {
    var obj = { device_id: deviceId, score: score, userId: deviceId, notes: notes }
    return apiPost({ endpoint: `${process.env.REACT_APP_WELLNESS_API_URL}/wellness`, body: obj, error_message: "Failed to add wellness record" });
};

export const fetchWorkerSignInHistory = async (deviceId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_WELLNESS_API_URL}/workersignin/${deviceId}`, error_message: "Failed to fetch worker history" });
};

export const updateWorkerSignInSetting = async (setting, deviceId, status) => {
    var obj = { id: setting.id, deviceId: deviceId, name: setting.name, friendlyName: setting.friendlyName, value: status.toString() }
    return apiPost({ endpoint: `${process.env.REACT_APP_DEVICE_API_URL}/update_setting`, body: obj, successMessage: `Worker sign-in ${status ? "enabled" : "disabled"} successfully!`, error_message: `Failed to ${status ? "enable" : "disable"} worker sign-in` });
};